import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/lib/lang";
import MarketingSite from "@/pages/MarketingSite";
import AppDetail from "@/pages/AppDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Marketplace from "@/pages/Marketplace";
import ProductDetail from "@/pages/ProductDetail";
import CreatorAuth from "@/pages/CreatorAuth";
import CreatorDashboard from "@/pages/CreatorDashboard";
import NonprofitPage from "@/pages/NonprofitPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ServicesPage from "@/pages/ServicesPage";
import ServicesPricing from "@/pages/ServicesPricing";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<MarketingSite />} />
        <Route path="/app/:appId" element={<AppDetail />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/marketplace/:productId" element={<ProductDetail />} />
        <Route path="/nonprofit" element={<NonprofitPage />} />
        <Route path="/creator" element={<CreatorAuth />} />
        <Route path="/creator/dashboard" element={<CreatorDashboard />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/pricing" element={<ServicesPricing />} />
      </Routes>
    </BrowserRouter>
    </LangProvider>
  );
}

export default App;
